import { ALLOWED_TICKS, FIRST_ELEMENT, OPTIMAL_MULTIPLE, STEP, TEN, ZERO } from '@constants';

import { roundToNearest } from './roundToNearest';

export const getChartTickInterval = (range: number[], tickCount: number, centerValue?: number) => {
  const minValue = range[FIRST_ELEMENT];
  const maxValue = range[range.length - STEP];
  const diff = maxValue - minValue;

  if (diff < tickCount) {
    if (diff === ZERO && centerValue !== undefined) {
      const interval = Math.ceil(Math.abs(centerValue - minValue) / OPTIMAL_MULTIPLE) * OPTIMAL_MULTIPLE;
      if (interval) {
        return { interval: interval, min: centerValue - interval, max: centerValue + interval };
      } else {
        return { interval: TEN, min: centerValue - TEN, max: centerValue + TEN };
      }
    }

    return { interval: STEP, min: Math.floor(minValue), max: Math.ceil(maxValue) };
  }

  const rawInterval = diff / (tickCount - STEP);
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval)));
  let interval = Math.ceil(rawInterval / magnitude) * magnitude;

  let min = Math.floor(minValue / interval) * interval;
  let max = Math.ceil(maxValue / interval) * interval;

  if (centerValue !== undefined) {
    const distanceToMin = Math.abs(centerValue - min);
    const distanceToMax = Math.abs(centerValue - max);

    if (distanceToMin > distanceToMax) {
      max = centerValue + (centerValue - min);
    } else {
      min = centerValue - (max - centerValue);
    }

    if (centerValue < min) {
      min = centerValue - interval * Math.floor((centerValue - minValue) / interval);
    }
    if (centerValue > max) {
      max = centerValue + interval * Math.ceil((maxValue - centerValue) / interval);
    }
  }

  interval = roundToNearest(Math.ceil((max - min) / (tickCount - STEP)), ALLOWED_TICKS);
  const outputMin = Math.floor(min / OPTIMAL_MULTIPLE) * OPTIMAL_MULTIPLE;
  const outputMax = Math.ceil(max / OPTIMAL_MULTIPLE) * OPTIMAL_MULTIPLE;

  if ((outputMax - outputMin) / interval > TEN) {
    const currentIndex = ALLOWED_TICKS.findIndex((tick) => tick === interval);
    if (currentIndex < ALLOWED_TICKS.length - STEP) {
      interval = ALLOWED_TICKS[currentIndex + STEP];
    }
  }

  return {
    interval,
    min: outputMin,
    max: outputMax,
  };
};
